/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./portfolio.scss";
import Portfoliolist from "../portfoliolist/Portfoliolist.jsx";
import {
  allPortfolio,
  gamesPortfolio,
  webPortfolio,
  modelsPortfolio,
} from "../../data";
import Footer from "../Footer/footer";

export default function portfolio() {
  const [selected, setSelected] = useState("all");
  const [data, setData] = useState([]);

  const list = [
    {
      id: "all",
      content: "All",
    },
    {
      id: "games",
      content: "Games",
    },
    {
      id: "web",
      content: "Websites",
    },
    {
      id: "3d",
      content: "3D Models",
    },
  ];

  useEffect(() => {
    switch (selected) {
      case "all":
        setData(allPortfolio);
        break;
      case "games":
        setData(gamesPortfolio);
        break;
      case "web":
        setData(webPortfolio);
        break;
      case "3d":
        setData(modelsPortfolio);
        break;
      default:
        setData(allPortfolio);
        break;
    }
  }, [selected]);

  return (
    <div className="portfolio" id="portfolio">
      <h1>Portfolio</h1>
      <ul>
        {list.map((item) => (
          <Portfoliolist
            id={item.id}
            title={item.content}
            active={selected === item.id}
            setSelected={setSelected}
          />
        ))}
      </ul>
      <div className="container">
        {data.map((d) => (
          <a href={d.url}>
            <div className="item">
              <img src={d.img} alt="title" />
              <h3>{d.title}</h3>
            </div>
          </a>
        ))}
      </div>
      <Footer />
    </div>
  );
}
